import { render } from "./Sendmessages.vue?vue&type=template&id=ac202c8e"
import script from "./Sendmessages.vue?vue&type=script&lang=js"
export * from "./Sendmessages.vue?vue&type=script&lang=js"

import "./Sendmessages.vue?vue&type=style&index=0&id=ac202c8e&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__